import React from "react";

import { useIntl, FormattedMessage } from "react-intl";

import Heading from "@atlaskit/heading";
import { Stack } from "@atlaskit/primitives";

import { SubjectAttributeKey } from "../../../../../analytics/constants";
import { ResourceCard } from "../../resource-card";

import { messages } from "./messages";

export const MigrationResources: React.FC = () => {
    const intl = useIntl();

    return (
        <Stack space="space.200">
            <Heading size="small">
                <FormattedMessage {...messages.resourcesTitle} />
            </Heading>
            <Stack space="space.300">
                <ResourceCard
                    title={intl.formatMessage(messages.smartSearchCardTitle)}
                    description={intl.formatMessage(
                        messages.smartSearchCardDescription
                    )}
                    href="https://support.atlassian.com/search-results/?searchTerm=cloud+migration"
                    buttonText={intl.formatMessage(
                        messages.smartSearchCardButton
                    )}
                    subject={SubjectAttributeKey.SEARCH_SUPPORT}
                />
                <ResourceCard
                    title={intl.formatMessage(messages.communityCardTitle)}
                    description={intl.formatMessage(
                        messages.communityCardDescription
                    )}
                    href="https://community.atlassian.com/learning/collection/topic/transition-to-atlassian-cloud"
                    buttonText={intl.formatMessage(
                        messages.communityCardButton
                    )}
                    subject={SubjectAttributeKey.ATLASSIAN_COMMUNITY}
                />
                <ResourceCard
                    title={intl.formatMessage(messages.cloudCardTitle)}
                    description={intl.formatMessage(
                        messages.cloudCardDescription
                    )}
                    buttonText={intl.formatMessage(messages.cloudCardButton)}
                    href="https://confluence.atlassian.com/alldoc/atlassian-documentation-32243719.html"
                    subject={SubjectAttributeKey.ATLASSIAN_DOCUMENTATION}
                />
            </Stack>
        </Stack>
    );
};
